import request from '@/utils/request'

//从环境变量获取auth服务的路径
const VUE_APP_BIZ_PATH = process.env.VUE_APP_BIZ_PATH
//从环境变量获取system服务的路径
const VUE_APP_ROLE_PATH = process.env.VUE_APP_ROLE_PATH

//初始化state
const state = {
}
  
  //定义getter
  const getters = {
    
  }

  //定义同步的操作，即mutation
const mutations = {
    
}

//定义异步的操作，即action
const actions = {
    /**
     * @description 查询场景列表
     * @return {Promise}
     */
    // eslint-disable-next-line no-unused-vars
    async getSceneList({ commit }, query) {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/scene/list`;
        const result = await request.get(url, {params:query});
        //获取服务返回数据
        return result;
    },
    // 查询场景详细
    async getScene({ commit }, { id }) {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/scene/${id}`;
        const result = await request.get(url);
        //获取服务返回数据
        return result;
    },
    // 修改场景
    async editScene(state, params) {
        let url = `${VUE_APP_BIZ_PATH}/enterprise/scene`;
        const result = await request.put(url, params);
        return result;
    },
    // 根据工厂查询车间
    async getWorkshopByFactory({ commit },params) {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/downList/workshop`;
        const result = await request.get(url,{params});
        //获取服务返回数据
        return result;
    },
    // 查询场景分布示意图
    async getSceneDistribution({ commit },{workshopId}){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/workshop/sceneLayout/${workshopId}`;
        const result = await request.get(url);
        //获取服务返回数据
        return result;
    },
    // 查询场景类型
    async getSceneTypes({ commit }) {
        //发起request
        const url = `${VUE_APP_ROLE_PATH}/dict/data/type/biz_scene_type`;
        const result = await request.get(url);
        //获取服务返回数据
        return result;
    },
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }